import Vue from 'vue';
import TreeViewSearch from './components/treeViewSearch.vue';
import router from "vue-router";
import i18n from './plugins/i18n';
import store from "./plugins/store";
import vClickOutside from 'v-click-outside';

Vue.use(vClickOutside);

(new Vue({
    el: '#treeViewSearch-component',
    router,
    i18n,
    store,
    render: h => h(TreeViewSearch),
    beforeCreate() {
        this.$store.dispatch('initializeStores');
    },
}));
